module.exports = __webpack_public_path__ + "ui-icons_ffffff_256x240.png?bf27228a7d3957983584fa7698121ea1";